import TileSubcategory from './TileSubcategory'

export default TileSubcategory
// eslint-disable-next-line import/export
export * from './TileSubcategory'
